import { defineNuxtRouteMiddleware } from '#imports'
import { asRouteMiddleware, redirectHomeIfLoggedIn } from '@utils/route-guards'

export default defineNuxtRouteMiddleware(asRouteMiddleware(redirectHomeIfLoggedIn))
